import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import Home from '../views/Home.vue'

import MainContent from '@/views/MainContent.vue'

import Agency from '@/views/Agency.vue'
import Corporate from '@/views/Corporate.vue'
import Contact from '@/views/Contact.vue'
import Legal from '@/views/Legal.vue'

import PhotosHome from '@/views/PhotosHome.vue'

import { usePhotoStore } from '@/stores/photo'
import { useCategoryStore } from '@/stores/category'
import { useUserStore } from '@/stores/user'
import { useLanguageStore } from '@/stores/language'

const routes: Array<RouteRecordRaw> = [
  /*
  {
    path: "/",
    name: "Maintenance",
    component: Maintenance,
  },
  */
  {
    path: '/',
    name: 'Home',
    component: Home,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import("../views/Home.vue")
    children: [
      {
        path: '',
        component: MainContent,
        children: [
          {
            path: '',
            component: PhotosHome,
          },
          {
            path: 'photos/sub_category/:category_id/:sub_category_id',
            component: () => import('../views/PhotosSubCategory.vue'),
          },
          {
            path: 'photos/category/:category_id',
            component: () => import('../views/PhotosCategory.vue'),
          },
          {
            path: 'photos/search/:search_type',
            component: () => import('../views/PhotosSearch.vue'),
          },
          {
            path: 'photos/season/search',
            component: () => import('../views/PhotosFromSeason.vue'),
          },
          {
            path: 'partners',
            component: () => import('../views/Partners.vue'),
          },
          {
            path: 'cart',
            component: () => import('../views/Cart.vue'),
          },
          // {
          //   path: 'cartHistory',
          //   component: () => import('../views/HistoryCarts.vue'),
          // },
          {
            path: 'users',
            component: () => import('../views/Users.vue'),
          },
          {
            path: 'photoValidation',
            component: () => import('../views/PhotoValidation.vue'),
          },
          {
            path: 'history',
            children: [
              {
                path: 'carts',
                component: () => import('../views/history/HistoryCarts.vue'),
              },
              {
                path: 'photos-ftp-received',
                component: () => import('../views/history/HistoryFtpReceived.vue'),
              },
              {
                path: 'logins',
                component: () => import('../views/history/HistoryLogins.vue'),
              },
              {
                path: 'photo-searchs',
                component: () => import('../views/history/HistoryPhotoSearchs.vue'),
              }
            ],
            component: () => import('../views/History.vue'),
          },
          // {
          //   path: 'uploadHistory',
          //   component: () => import('../views/UploadHistory.vue'),
          // },
          {
            path: 'videos',
            component: () => import('../views/Videos.vue'),
          },
          {
            path: 'statistics',
            component: () => import('../views/Statistics.vue'),
          },
        ],
      },
      {
        path: 'agency',
        component: Agency,
        meta: { transition: 'slide-left' },
      },
      {
        path: 'corporate',
        component: Corporate,
        meta: { transition: 'slide-left' },
      },
      {
        path: 'contact',
        component: Contact,
        meta: { transition: 'slide-left' },
      },
      {
        path: 'legal',
        component: Legal,
        meta: { transition: 'slide-left' },
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to, from) => {
  const photoStore = usePhotoStore()
  const categoryStore = useCategoryStore()
  const userStore = useUserStore()
  const languageStore = useLanguageStore()

  /*
   "features":[
      "upload_history",
      "admin",
      "iptc",
      "cart_history",
      "users",
      "cart",
      "validation"
  */
  // Check the path needed permission against the user permissions

  if (
    (to.path === '/cartHistory' &&
      !userStore.checkFeatureAccess('cart_history')) ||
    (to.path === '/users' && !userStore.checkFeatureAccess('users')) ||
    (to.path === '/photoValidation' &&
      !userStore.checkFeatureAccess('validation')) ||
    (to.path === '/uploadHistory' &&
      !userStore.checkFeatureAccess('upload_history'))
  ) {
    console.log('beforeEach inside')

    router.push({ path: '/', replace: true })
  }
  /*
  else if ((to.path === '/results' && from.path === '/' && photoStore.getSearchText === null)
    || (!userStore.isAdmin && to.path.toLocaleLowerCase().includes('admin'))) {
    console.log("beforeEach inside")

    router.push({ path: '/', replace: true })
  }
  */
})

export default router
